module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    attrs: {
      "id": "assign-tab"
    }
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row background-white"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "panel-content-inner w-full",
    class: ((_vm.bookingsCheckings.length === 1 && _vm.bookingsCheckouts.length === 0) || (_vm.bookingsCheckings.length === 0 && _vm.bookingsCheckouts.length === 1)) ? 'line-height-table' : ''
  }, [_c('div', {
    staticClass: "row d-flex justify-content-around"
  }, [_c('div', {
    staticClass: "jobs-desc text-center"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.statusCounts.toBeAssigned))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.toBeAssigned),
      expression: "!editable.toBeAssigned"
    }],
    staticClass: "desc desc-be-assigned",
    on: {
      "click": function($event) {
        _vm.enableEditing('toBeAssigned')
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.getStatusName(1) ? _vm.getStatusName(1) : _vm.$t('calendar.jobs.to_be_assigned')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.toBeAssigned),
      expression: "editable.toBeAssigned"
    }],
    staticClass: "desc desc-be-assigned"
  }, [_c('input', {
    ref: "toBeAssigned",
    domProps: {
      "value": _vm.getStatusName(1) ? _vm.getStatusName(1) : _vm.$t('calendar.jobs.to_be_assigned')
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('toBeAssigned', 1, $event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "jobs-desc text-center"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.statusCounts.assigned))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.assigned),
      expression: "!editable.assigned"
    }],
    staticClass: "desc desc-assigned",
    on: {
      "click": function($event) {
        _vm.enableEditing('assigned')
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.getStatusName(2) ? _vm.getStatusName(2) : _vm.$t('calendar.jobs.assigned')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.assigned),
      expression: "editable.assigned"
    }],
    staticClass: "desc desc-assigned"
  }, [_c('input', {
    ref: "assigned",
    domProps: {
      "value": _vm.getStatusName(2) ? _vm.getStatusName(2) : _vm.$t('calendar.jobs.assigned')
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('assigned', 2, $event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "jobs-desc text-center"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.statusCounts.done))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.done),
      expression: "!editable.done"
    }],
    staticClass: "desc desc-done",
    on: {
      "click": function($event) {
        _vm.enableEditing('done')
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.getStatusName(3) ? _vm.getStatusName(3) : _vm.$t('calendar.jobs.done')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.done),
      expression: "editable.done"
    }],
    staticClass: "desc desc-done"
  }, [_c('input', {
    ref: "done",
    domProps: {
      "value": _vm.getStatusName(3) ? _vm.getStatusName(3) : _vm.$t('calendar.jobs.done')
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('done', 3, $event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "jobs-desc text-center"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.statusCounts.cancelled))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.cancelled),
      expression: "!editable.cancelled"
    }],
    staticClass: "desc desc-cancelled",
    on: {
      "click": function($event) {
        _vm.enableEditing('cancelled')
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.getStatusName(4) ? _vm.getStatusName(4) : _vm.$t('calendar.jobs.cancelled')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.cancelled),
      expression: "editable.cancelled"
    }],
    staticClass: "desc desc-cancelled"
  }, [_c('input', {
    ref: "cancelled",
    domProps: {
      "value": _vm.getStatusName(4) ? _vm.getStatusName(4) : _vm.$t('calendar.jobs.cancelled')
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('cancelled', 4, $event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "jobs-desc text-center"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.statusCounts.cleaningFast))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable.cleaningFast),
      expression: "!editable.cleaningFast"
    }],
    staticClass: "desc desc-cleaning",
    on: {
      "click": function($event) {
        _vm.enableEditing('cleaningFast')
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.getStatusName(5) ? _vm.getStatusName(5) : _vm.$t('calendar.jobs.cleaning_fast')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editable.cleaningFast),
      expression: "editable.cleaningFast"
    }],
    staticClass: "desc desc-cleaning"
  }, [_c('input', {
    ref: "cleaningFast",
    domProps: {
      "value": _vm.getStatusName(5) ? _vm.getStatusName(5) : _vm.$t('calendar.jobs.cleaning_fast')
    },
    on: {
      "blur": function($event) {
        _vm.autoSave('cleaningFast', 5, $event)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-15 background-white"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "panel-content-inner w-full",
    class: ((_vm.bookingsCheckings.length === 1 && _vm.bookingsCheckouts.length === 0) || (_vm.bookingsCheckings.length === 0 && _vm.bookingsCheckouts.length === 1)) ? 'line-height-table' : ''
  }, [_c('div', {
    staticClass: "row justify-content-between m-t-15"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMember),
      expression: "selectedMember"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMember = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t('calendar.jobs.assign_to')))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.teamMembers), function(member) {
    return _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v(_vm._s(member.first_name + ' ' + member.last_name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 m-t-5"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save apply-btn",
    attrs: {
      "disabled": !_vm.isAtLeastOneBookingChecked
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.assignCheckedBookingsToMember()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.apply')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3 m-t-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2 d-flex justify-content-center align-items-center"
  }, [_c('a', {
    staticClass: "arrow-left cursor-pointer",
    on: {
      "click": function($event) {
        _vm.changeDay('prev')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/arrow-left3.svg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('span', [_c('date-picker', {
    staticClass: "datepicker",
    attrs: {
      "type": "date",
      "lang": "en",
      "clearable": false,
      "width": "100%",
      "input-class": "mx-input input-date",
      "format": "MMM DD, YYYY"
    },
    on: {
      "change": function($event) {
        _vm.changeDay('selected')
      }
    },
    model: {
      value: (_vm.selectedDay),
      callback: function($$v) {
        _vm.selectedDay = $$v
      },
      expression: "selectedDay"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-2 d-flex justify-content-center align-items-center"
  }, [_c('a', {
    staticClass: "pull-right arrow-right cursor-pointer",
    on: {
      "click": function($event) {
        _vm.changeDay('next')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/arrow-right3.svg"
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-15 background-white"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "panel-content-inner w-full",
    class: ((_vm.bookingsCheckings.length === 1 && _vm.bookingsCheckouts.length === 0) || (_vm.bookingsCheckings.length === 0 && _vm.bookingsCheckouts.length === 1)) ? 'line-height-table' : ''
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "bookings-table"
    }
  }, [_c('div', {}, [_c('h2', [_vm._v(_vm._s(_vm.$t('calendar.jobs.checkins')) + " (" + _vm._s(_vm.bookingsCheckings.length) + ")")]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.bookingsCheckings.length > 0),
      expression: "!loading && bookingsCheckings.length > 0"
    }],
    staticClass: "bookings-table-sizes row-link table table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "booking-detail"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkingsChecked),
      expression: "checkingsChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkingsChecked) ? _vm._i(_vm.checkingsChecked, null) > -1 : (_vm.checkingsChecked)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkingsChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkingsChecked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkingsChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkingsChecked = $$c
        }
      }, function($event) {
        _vm.checkOrUncheckBookings('checking')
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "booking-id"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('booking.index.status_title')))])]), _vm._v(" "), _c('th', {
    staticClass: "booking-rental"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('booking.index.rental')))])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.guest')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.checkin')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.checkout')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.nights')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.adults')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.children')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.checkin_hour')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.index.notes')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-channel",
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v(_vm._s(_vm.$t('messages.index.platform')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-channel",
    staticStyle: {
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.index.assigned_to')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-action",
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bookingsCheckings), function(booking, index) {
    return _c('tr', [_c('td', {
      staticClass: "booking-id booking-detail"
    }, [_c('div', {
      attrs: {
        "id": "booking-id-td"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (booking.checked),
        expression: "booking.checked"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(booking.checked) ? _vm._i(booking.checked, null) > -1 : (booking.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = booking.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(booking, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(booking, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(booking, "checked", $$c)
          }
        }, _vm.checkCheckedBookings]
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "booking-action statuses",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(index, booking, booking.rental)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('span', {
      staticClass: "status-circle",
      class: _vm.getClass(booking.checking_assign_status ? booking.checking_assign_status.id : false)
    }, [_vm._v(_vm._s(booking.checking_assign_status && _vm.getStatusName(booking.checking_assign_status.id) ? _vm.getStatusName(booking.checking_assign_status.id) : _vm.getStatusTranslation(booking.checking_assign_status ? booking.checking_assign_status.id : false)))])])])]), _vm._v(" "), _c('td', {
      staticClass: "booking-rental booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(index, booking, booking.rental)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(booking.rental.name))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-guest booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(index, booking, booking.rental)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(booking.guest.first_name) + " " + _vm._s(booking.guest.last_name))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-checkin booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(index, booking, booking.rental)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(booking.checking))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-checkout booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(index, booking, booking.rental)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(booking.checkout))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-nights booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(index, booking, booking.rental)
        }
      }
    }, [_c('div', [_c('i', {
      staticClass: "icon-rental-moon"
    }), _vm._v(_vm._s(_vm._f("calculateNight")(booking.checking, booking.checkout)))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-people booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(index, booking, booking.rental)
        }
      }
    }, [_c('div', [_c('i', {
      staticClass: "icon-rental-user"
    }), _vm._v(_vm._s(booking.nbr_adults))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-children booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(index, booking, booking.rental)
        }
      }
    }, [_c('div', [_c('i', {
      staticClass: "icon-rental-user"
    }), _vm._v(_vm._s(booking.nbr_children))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-children booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(index, booking, booking.rental)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(booking.time_in || "-"))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(booking.extra_data_from_form['notes']))]), _vm._v(" "), _c('td', {
      staticClass: "booking-channel",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(index, booking, booking.rental)
        }
      }
    }, [_c('div', {
      class: (booking.channel && booking.channel.logo === 'hotels2.png') ? 'hotels2' : 'd-flex justify-content-center align-items-center'
    }, [_c('img', {
      class: (booking.channel && booking.channel.logo) ? '' : 'default-rent',
      attrs: {
        "src": booking.channel && booking.channel.logo ? ("static/assets/images/" + (booking.channel.logo)) : '/static/assets/images/SuperHote_icons/rent.png'
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "booking-channel team-members",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(index, booking, booking.rental)
        }
      }
    }, [_c('div', [_vm._v("\n                                " + _vm._s(_vm.showCheckingCheckoutAssignName(booking, 'checking')) + "\n                              ")])]), _vm._v(" "), _c('td', {
      staticClass: "booking-actions"
    }, [_c('div', {
      staticClass: "row justify-content-center action-padding pos-rel"
    }, [_c('div', {
      staticClass: "col-6 column-padding"
    }, [_c('div', {
      staticClass: "row action-padding"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('div', {
      staticClass: "dropdown padding-none dropup"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right add-members"
    }, [_c('ul', {
      staticClass: "add-member-list"
    }, _vm._l((_vm.statuses), function(status) {
      return _c('li', {
        staticClass: "add-member-list-item",
        class: booking.checking_assign_status === status ? 'list-selected' : '',
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.changeAssignStatus(index, booking.id, status.id, 'checking')
          }
        }
      }, [_vm._v(_vm._s(status.name) + "\n                                            ")])
    }))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_c('div', {
      staticClass: "dropdown padding-none dropup"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right add-members"
    }, [_c('ul', {
      staticClass: "add-member-list"
    }, [(booking.assigned_to_checking) ? _c('li', {
      staticClass: "add-member-list-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.addOrChangeTeamMember(index, booking.id, null, 'checking')
        }
      }
    }, [_vm._v("Unassign")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.teamMembers), function(member, i) {
      return _c('li', {
        staticClass: "add-member-list-item",
        class: booking.assigned_to_checking == member.id ? 'list-selected' : '',
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.addOrChangeTeamMember(index, booking.id, member.id, 'checking')
          }
        }
      }, [_vm._v(_vm._s(member.first_name) + "\n                                            ")])
    })], 2)])])])])])])])])
  }))])]), _vm._v(" "), _c('div', {}, [_c('h2', [_vm._v(_vm._s(_vm.$t('calendar.jobs.checkouts')) + " (" + _vm._s(_vm.bookingsCheckouts.length) + ")")]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.bookingsCheckouts.length > 0),
      expression: "!loading && bookingsCheckouts.length > 0"
    }],
    staticClass: "bookings-table-sizes row-link table table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "booking-detail"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkoutsChecked),
      expression: "checkoutsChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkoutsChecked) ? _vm._i(_vm.checkoutsChecked, null) > -1 : (_vm.checkoutsChecked)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkoutsChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkoutsChecked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkoutsChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkoutsChecked = $$c
        }
      }, function($event) {
        _vm.checkOrUncheckBookings('checkout')
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "booking-id"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('booking.index.status_title')))])]), _vm._v(" "), _c('th', {
    staticClass: "booking-rental"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('booking.index.rental')))])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.guest')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.checkin')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.checkout')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-nights"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.nights')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-people"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.adults')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.children')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.checkout_hour')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.index.notes')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-channel",
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v(_vm._s(_vm.$t('messages.index.platform')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-channel",
    staticStyle: {
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.index.assigned_to')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-action",
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.index.status_title')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bookingsCheckouts), function(booking, checkoutIndex) {
    return _c('tr', [_c('td', {
      staticClass: "booking-id booking-detail"
    }, [_c('div', {
      attrs: {
        "id": ""
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (booking.checked),
        expression: "booking.checked"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(booking.checked) ? _vm._i(booking.checked, null) > -1 : (booking.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = booking.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(booking, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(booking, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(booking, "checked", $$c)
          }
        }, _vm.checkCheckedBookings]
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "booking-action statuses",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(checkoutIndex, booking, booking.rental)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('span', {
      staticClass: "status-circle",
      class: _vm.getClass(booking.checkout_assign_status ? booking.checkout_assign_status.id : false)
    }, [_vm._v(_vm._s(booking.checkout_assign_status && _vm.getStatusName(booking.checkout_assign_status.id) ? _vm.getStatusName(booking.checkout_assign_status.id) : _vm.getStatusTranslation(booking.checkout_assign_status ? booking.checkout_assign_status.id : false)))])])])]), _vm._v(" "), _c('td', {
      staticClass: "booking-rental booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(checkoutIndex, booking, booking.rental)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(booking.rental.name))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-guest booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(checkoutIndex, booking, booking.rental)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(booking.guest.first_name) + " " + _vm._s(booking.guest.last_name))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-checkin booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(checkoutIndex, booking, booking.rental)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(booking.checking))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-checkout booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(checkoutIndex, booking, booking.rental)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(booking.checkout))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-nights booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(checkoutIndex, booking, booking.rental)
        }
      }
    }, [_c('div', [_c('i', {
      staticClass: "icon-rental-moon"
    }), _vm._v(" " + _vm._s(_vm._f("calculateNight")(booking.checking, booking.checkout)))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-people booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(checkoutIndex, booking, booking.rental)
        }
      }
    }, [_c('div', [_c('i', {
      staticClass: "icon-rental-user"
    }), _vm._v(" " + _vm._s(booking.nbr_adults))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-people booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(checkoutIndex, booking, booking.rental)
        }
      }
    }, [_c('div', [_c('i', {
      staticClass: "icon-rental-user"
    }), _vm._v(" " + _vm._s(booking.nbr_children))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-people booking-detail",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(checkoutIndex, booking, booking.rental)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(booking.time_out || "-"))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(booking.extra_data_from_form['notes']))]), _vm._v(" "), _c('td', {
      staticClass: "booking-channel",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(checkoutIndex, booking, booking.rental)
        }
      }
    }, [_c('div', {
      class: (booking.channel && booking.channel.logo == 'hotels2.png') ? 'hotels2' : ((booking.channel && booking.channel.logo) ? '' : 'd-flex justify-content-center align-items-center')
    }, [_c('img', {
      class: (booking.channel && booking.channel.logo) ? '' : 'default-rent',
      attrs: {
        "src": booking.channel && booking.channel.name != 'Direct' ? 'static/assets/images/' + booking.channel.logo : '/static/assets/images/SuperHote_icons/rent.png'
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "booking-channel team-members",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDetail(checkoutIndex, booking, booking.rental)
        }
      }
    }, [_c('div', [_vm._v("\n                                " + _vm._s(_vm.showCheckingCheckoutAssignName(booking, 'checkout')) + "\n                              ")])]), _vm._v(" "), _c('td', {
      staticClass: "booking-actions"
    }, [_c('div', {
      staticClass: "row justify-content-center action-padding pos-rel"
    }, [_c('div', {
      staticClass: "col-6 column-padding"
    }, [_c('div', {
      staticClass: "row action-padding"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('div', {
      staticClass: "dropdown padding-none dropup"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right add-members"
    }, [_c('ul', {
      staticClass: "add-member-list"
    }, _vm._l((_vm.statuses), function(status, statusIndex) {
      return _c('li', {
        staticClass: "add-member-list-item",
        class: booking.checkout_assign_status == status ? 'list-selected' : '',
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.changeAssignStatus(checkoutIndex, booking.id, status.id, 'checkout')
          }
        }
      }, [_vm._v(_vm._s(_vm.getStatusName(status.id) ? _vm.getStatusName(status.id) : _vm.getStatusTranslation(status.id)) + "\n                                            ")])
    }))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_c('div', {
      staticClass: "dropdown padding-none dropup"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right add-members"
    }, [_c('ul', {
      staticClass: "add-member-list"
    }, [(booking.assigned_to_checkout) ? _c('li', {
      staticClass: "add-member-list-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.addOrChangeTeamMember(checkoutIndex, booking.id, null, 'checkout')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('calendar.jobs.unassign')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.teamMembers), function(member) {
      return _c('li', {
        staticClass: "add-member-list-item",
        class: booking.assigned_to_checkout == member.id ? 'list-selected' : '',
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.addOrChangeTeamMember(checkoutIndex, booking.id, member.id, 'checkout')
          }
        }
      }, [_vm._v(_vm._s(member.first_name) + "\n                                            ")])
    })], 2)])])])])])])])])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bookingDetails),
      expression: "bookingDetails"
    }],
    staticClass: "calendar-month-view"
  }, [_c('div', {
    staticClass: "panel panel-white left"
  }, [_c('div', {
    staticClass: "pannel_sec"
  }, [_c('div', {
    staticClass: "cross_icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeDetailModal()
      }
    }
  }, [_vm._v(" x ")]), _vm._v(" "), _c('div', {
    staticClass: "pannel_details"
  }, [_c('h2', {
    staticClass: "tle_p"
  }, [_c('div', {
    staticClass: "event-fullname"
  }, [_vm._v("\n                                " + _vm._s(_vm.guestItem.first_name ? _vm.guestItem.first_name : '') + " " + _vm._s(_vm.guestItem.last_name ? _vm.guestItem.last_name : '') + "\n                              ")]), _vm._v(" "), _c('span', [_vm._v("("), _c('span', {
    staticClass: "event-bookingid"
  }, [_vm._v(_vm._s(_vm.bookingItem.id))]), _vm._v(") ")])]), _vm._v(" "), _c('div', {
    staticClass: "c_date c_date_a"
  }, [_c('p', {
    staticClass: "margin-bottom-10"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.rental_name')) + " : "), _c('span', [_vm._v(_vm._s(_vm.rentalItem.name))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.booking_date')) + " : "), (_vm.bookingItem.booking_date) ? _c('span', {
    staticClass: "event-checkin"
  }, [_vm._v(_vm._s(_vm._f("getWeekDayFromDateCalendar")(_vm.bookingItem.booking_date)))]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.checkin')) + " : "), (_vm.bookingItem.checking) ? _c('span', {
    staticClass: "event-checkin"
  }, [_vm._v(_vm._s(_vm._f("getWeekDayFromDate")(_vm.bookingItem.checking)))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "margin-bottom-10"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.checkout')) + " : "), (_vm.bookingItem.checkout) ? _c('span', {
    staticClass: "event-checkout"
  }, [_vm._v(_vm._s(_vm._f("getWeekDayFromDate")(_vm.bookingItem.checkout)))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "event_referer"
  }), _vm._v(" "), _c('p', {
    staticClass: "mb-10"
  }, [_c('span', {
    staticClass: "event-adults"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('calendar.booking-detail.nb_adults')) + " : " + _vm._s(_vm.bookingItem.nbr_adults) + "\n                                  ")]), _vm._v("\n                                  -\n                                  "), _c('span', {
    staticClass: "event-children"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.nb_children')) + " : " + _vm._s(_vm.bookingItem.nbr_children))])]), _vm._v(" "), (_vm.bookingItem.booking_com_res_id) ? _c('p', {
    staticClass: "margin-bottom-10"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.reservation_status")) + " : "), _c('span', [_vm._v(_vm._s(_vm.getReservationStatusName(_vm.bookingItem.reservation_status)))])]) : _vm._e(), _vm._v(" "), ((_vm.user.is_team_member && _vm.user.rights && _vm.user.rights.booking_prices) || !_vm.user.is_team_member) ? _c('div', {
    staticClass: "margin-bottom-15 price"
  }, [_vm._v("\n                                  " + _vm._s(_vm.getBookingChannelName(_vm.channelItem, _vm.bookingItem.original_referrer, _vm.bookingItem.ical)) + "\n                                  "), _c('span', [_vm._v("("), _c('span', [_vm._v(_vm._s(_vm.getPriceAmount(_vm.bookingItem)))]), _vm._v(" " + _vm._s(_vm.rentalItem.currency ? _vm.rentalItem.currency.symbol : '€') + ")")]), _vm._v(" "), (_vm.bookingUrl) ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.bookingUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.booking_page')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member || (_vm.user.is_team_member && _vm.user.rights && _vm.showBookingActions)) ? _c('p', {
    class: _vm.isExtraDataLong(_vm.bookingItem.extra_data_from_form) ? 'overflow-panel-notes panel-notes' : 'panel-notes'
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('input.notes')) + " :\n                                  "), _c('span', [_vm._v(_vm._s(_vm.getBookingExtraDetails(_vm.bookingItem.extra_data_from_form)))])]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member || (_vm.user.is_team_member && _vm.user.rights && _vm.showBookingActions)) ? _c('p', {
    class: _vm.isExtraDataLong(_vm.bookingItem.extra_data_from_form, 'comments') ? 'overflow-panel-notes panel-notes margin-bottom-10' : 'panel-notes margin-bottom-10'
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('booking.detail.events.comments')) + " :\n                                  "), _c('span', [_vm._v(_vm._s(_vm.getBookingExtraDetails(_vm.bookingItem.extra_data_from_form, 'comments')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form_group_attached"
  }, [_c('div', {
    staticClass: "form_group_half"
  }, [_c('div', {
    staticClass: "form_group form_group_half_col"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.arrival')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-arrival"
  }, [_vm._v(_vm._s(_vm.bookingItem.time_in ? _vm.bookingItem.time_in : 'N/A'))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group form_group_half_col"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.departure')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-arrival"
  }, [_vm._v(_vm._s(_vm.bookingItem.time_out ? _vm.bookingItem.time_out : 'N/A'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.email')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-email"
  }, [_vm._v(_vm._s(_vm.guestItem.email ? _vm.guestItem.email : "N/A"))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.mobile')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-phone"
  }, [_vm._v(_vm._s(_vm.guestItem ? _vm.guestItem.phone : "N/A"))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group_half form-control-margin-0"
  }, [_c('div', {
    staticClass: "form_group form_group_half_col form-group-default"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.payment')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-payment"
  }, [_vm._v(_vm._s(_vm.bookingItem.status === 1 && _vm.bookingItem.payment_is_done === 1 ? 'OK' : 'KO'))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group form_group_half_col form-group-default"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.deposit')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "box event-deposit"
  }, [_vm._v(_vm._s(_vm.bookingItem.statusCode !== 14 && _vm.bookingItem.deposit_is_done === 1 ? 'OK' : 'KO'))])]), _vm._v(" "), _c('div', {
    staticClass: "form_group form_group_half_col form-group-default"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.welcome_form_submitted")) + " ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingItem.welcome_form_submitted),
      expression: "bookingItem.welcome_form_submitted"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bookingItem, "welcome_form_submitted", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.changeFormStatus('welcome', _vm.bookingItem)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("KO")])])]), _vm._v(" "), _c('div', {
    staticClass: "form_group form_group_half_col form-group-default"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t("calendar.booking-detail.checkin_form_submitted")) + " ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingItem.checkin_form_submitted),
      expression: "bookingItem.checkin_form_submitted"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bookingItem, "checkin_form_submitted", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.changeFormStatus('checkin', _vm.bookingItem)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("KO")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form_group_half_col form-group-default"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('label', {
    staticClass: "booking-status"
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.to_throw_back')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified",
    attrs: {
      "title": _vm.$t('calendar.booking-detail.follow_up_info')
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingItem.follow_up),
      expression: "bookingItem.follow_up"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bookingItem, "follow_up", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.onChangeFollowUp()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.yes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.no')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form_group_half_col form-group-default"
  }, [_c('div', {
    staticClass: "d-flex contract-status"
  }, [_c('label', {
    staticClass: "booking-status "
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.contract.title')) + " ")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "box"
  }, [_vm._v(_vm._s(_vm.bookingItem.is_booking_contract_signed ? _vm.$t('booking.detail.signed') : _vm.$t('booking.detail.not_signed')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form_group_half form-control-margin-0"
  }, [_c('div', {
    staticClass: "form_group form-group-default form_group_half_col border-top-0"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('account.users.teamMember.assignCheckin')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingItem.assigned_to_checking),
      expression: "bookingItem.assigned_to_checking"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bookingItem, "assigned_to_checking", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.addOrChangeTeamMember(_vm.bookingIndex, _vm.bookingItem.id, _vm.bookingItem.assigned_to_checking, 'checking')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-")]), _vm._v(" "), _vm._l((_vm.membersForChecking), function(member) {
    return _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v(_vm._s(((member.first_name) + " " + (member.last_name))))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form_group form-group-default form_group_half_col border-top-0"
  }, [_c('label', {
    staticClass: "fade"
  }, [_vm._v(_vm._s(_vm.$t('account.users.teamMember.assignCheckout')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingItem.assigned_to_checkout),
      expression: "bookingItem.assigned_to_checkout"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bookingItem, "assigned_to_checkout", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.addOrChangeTeamMember(_vm.bookingIndex, _vm.bookingItem.id, _vm.bookingItem.assigned_to_checkout, 'checkout')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-")]), _vm._v(" "), _vm._l((_vm.membersForCheckout), function(member) {
    return _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v(_vm._s(((member.first_name) + " " + (member.last_name))))])
  })], 2)])])]), _vm._v(" "), (!_vm.user.is_team_member || (_vm.user.is_team_member === 1 && _vm.user.rights && _vm.showBookingActions)) ? _c('div', {
    staticClass: "other-actions"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bookingItem.areLocksConnectedToBookingRental && !_vm.user.is_team_member),
      expression: "bookingItem.areLocksConnectedToBookingRental && !user.is_team_member"
    }],
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openModal('#controlLocks-modal')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t('rentals.detail.locks_management')))]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toBooking(_vm.bookingItem.id, 'invoices')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t("button.view_invoice")))]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toBooking(_vm.bookingItem.id, 'payments')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t("button.view_payment")))]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toBooking(_vm.bookingItem.id, 'contract')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.contract.title")))]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toBooking(_vm.bookingItem.id, 'messages')
      }
    }
  }, [_c('label', {
    staticClass: "pull-left cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t("button.view_messages")))]), _vm._v(" "), _vm._m(8)])]) : _vm._e(), _vm._v(" "), ((_vm.user.is_team_member && _vm.user.rights && _vm.showBookingPrices && _vm.showBookingActions) || !_vm.user.is_team_member) ? _c('div', {
    staticClass: "btnn"
  }, [_c('button', {
    staticClass: " btn waves-effect waves-classic button-booking-detail p-0",
    attrs: {
      "id": "eventSave"
    },
    on: {
      "click": function($event) {
        _vm.toBooking(_vm.bookingItem.id, 'informations', true)
      }
    }
  }, [_c('a', {
    staticClass: "button-booking-detail",
    attrs: {
      "href": ("#/bookings/" + (_vm.bookingItem.id) + "/informations")
    }
  }, [_vm._v(_vm._s(_vm.$t('button.booking_details')))])])]) : _vm._e()])])])])])])])])])]), _vm._v(" "), _c('v-manage-locks', {
    attrs: {
      "rental": Object.assign({}, _vm.bookingItem.rental),
      "booking": Object.assign({}, _vm.bookingItem)
    }
  })], 1)])])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "action-icons plus-icon dropdown-toggle ",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "far fa-bars"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "action-icons plus-icon dropdown-toggle ",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "far fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "action-icons plus-icon dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "far fa-bars"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "action-icons plus-icon dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "far fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon md-chevron-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon md-chevron-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon md-chevron-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon md-chevron-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-10"
  }, [_c('a', {
    staticClass: "custom-action-link",
    staticStyle: {
      "width": "100%",
      "color": "inherit"
    },
    attrs: {
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "pull-right p-r-10 p-b-5"
  }, [_c('i', {
    staticClass: "icon md-chevron-right"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6db8c80"}!./src/app/pages/calendar/scheduler/assign/assign.html
// module id = 1444
// module chunks = 0